export const nameBankArrayList = [
  {
    id: '014',
    value: 'ธนาคาร ไทยพาณิชย์',
  },
  {
    id: '002',
    value: 'ธนาคาร กรุงเทพ',
  },
  {
    id: '004',
    value: 'ธนาคาร กสิกรไทย',
  },
  {
    id: '006',
    value: 'ธนาคาร กรุงไทย',
  },
  {
    id: '034',
    value: 'ธนาคาร ธกส',
  },
  {
    id: '011',
    value: 'ธนาคาร ทีเอ็มบีธนชาต',
  },
  {
    id: '017',
    value: 'ธนาคาร ซิตี้แบงก์',
  },
  {
    id: '020',
    value: 'ธนาคาร สแตนดาร์ดชาร์เตอร์ด',
  },
  {
    id: '022',
    value: 'ธนาคาร ซีไอเอ็มบี',
  },
  {
    id: '024',
    value: 'ธนาคาร ยูโอบี',
  },
  {
    id: '025',
    value: 'ธนาคาร กรุงศรีฯ',
  },
  {
    id: '030',
    value: 'ธนาคาร ออมสิน',
  },
  {
    id: '033',
    value: 'ธนาคาร ธอส',
  },
  {
    id: '073',
    value: 'ธนาคาร แลนด์แอนด์เฮ้าส',
  },
  {
    id: '067',
    value: 'ธนาคาร ทิสโก้',
  },
  {
    id: '069',
    value: 'ธนาคาร เกียรตินาคิน',
  },
  {
    id: '066',
    value: 'ธนาคาร อิสลาม',
  },
]



// WEBPACK FOOTER //
// ./src/config/Bank.js